@if (photos.length) {
  <div class="pg" [class.pg--compact]="compact">
    @if (label) {
      <div class="pg-label">{{ label }}</div>
    }
    <div class="pg-grid">
      @for (p of photos; track p.id; let i = $index) {
        <button class="pg-thumb" type="button" (click)="open(i)"
                [attr.aria-label]="p.caption || 'View proof photo ' + (i + 1)">
          <img [src]="p.imageUrl" [alt]="p.caption || 'Proof photo ' + (i + 1)" loading="lazy" />
          @if (p.caption) {
            <span class="pg-cap">{{ p.caption }}</span>
          }
        </button>
      }
    </div>
  </div>
} @else if (emptyText) {
  <div class="pg-empty">{{ emptyText }}</div>
}

<!-- Lightbox. Fixed to the viewport so it escapes the card/modal it was rendered in. -->
@if (zoomIdx() >= 0 && photos[zoomIdx()]; as z) {
  <div class="pg-lb" (click)="close()">
    <button class="pg-lb-x" type="button" (click)="close()" aria-label="Close">&times;</button>

    @if (photos.length > 1) {
      <button class="pg-lb-nav pg-lb-prev" type="button" aria-label="Previous"
              (click)="$event.stopPropagation(); prev()">&lsaquo;</button>
      <button class="pg-lb-nav pg-lb-next" type="button" aria-label="Next"
              (click)="$event.stopPropagation(); next()">&rsaquo;</button>
    }

    <figure class="pg-lb-fig" (click)="$event.stopPropagation()">
      <img [src]="z.imageUrl" [alt]="z.caption || 'Proof photo'" />
      <figcaption class="pg-lb-cap">
        @if (z.caption) { <span class="pg-lb-cap-t">{{ z.caption }}</span> }
        @if (photos.length > 1) {
          <span class="pg-lb-count">{{ zoomIdx() + 1 }} / {{ photos.length }}</span>
        }
      </figcaption>
    </figure>
  </div>
}
